'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _activityType = require('./activityType.service');

var _activityType2 = _interopRequireDefault(_activityType);

var _buildNumber = require('./buildNumber.service');

var _buildNumber2 = _interopRequireDefault(_buildNumber);

var _careType = require('./careType.service');

var _careType2 = _interopRequireDefault(_careType);

var _changeCategory = require('./changeCategory.service');

var _changeCategory2 = _interopRequireDefault(_changeCategory);

var _coder = require('./coder.service');

var _coder2 = _interopRequireDefault(_coder);

var _constant = require('./constant.service');

var _constant2 = _interopRequireDefault(_constant);

var _dateFormatter = require('./dateFormatter.service');

var _dateFormatter2 = _interopRequireDefault(_dateFormatter);

var _function = require('./function.service');

var _function2 = _interopRequireDefault(_function);

var _queryModalOption = require('./queryModalOption.service');

var _queryModalOption2 = _interopRequireDefault(_queryModalOption);

var _queryDetails = require('./queryDetails.service');

var _queryDetails2 = _interopRequireDefault(_queryDetails);

var _auditRule = require('./auditRule.service');

var _auditRule2 = _interopRequireDefault(_auditRule);

var _episodeDrgAuditType = require('./episodeDrgAuditType.service');

var _episodeDrgAuditType2 = _interopRequireDefault(_episodeDrgAuditType);

var _v = require('./v2.service');

var _v2 = _interopRequireDefault(_v);

var _modal = require('./modal.service');

var _modal2 = _interopRequireDefault(_modal);

var _version = require('./version.service');

var _version2 = _interopRequireDefault(_version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var servicesModule = _angular2.default.module('services', [])

// Register new services here
.factory('ActivityType', _activityType2.default).factory('BuildNumber', _buildNumber2.default).factory('CareType', _careType2.default).factory('ChangeCategory', _changeCategory2.default).factory('CoderService', _coder2.default).factory('Constants', _constant2.default).factory('DateFormatter', _dateFormatter2.default).factory('QueryDetails', _queryDetails2.default).factory('FunctionService', _function2.default).factory('QueryModalOptions', _queryModalOption2.default).factory('EpisodeDrgAuditTypeService', _episodeDrgAuditType2.default).factory('V2Service', _v2.default).factory('AuditRuleService', _auditRule2.default).factory('ModalService', _modal2.default).factory('VersionService', _version2.default);

exports.default = servicesModule;


// WEBPACK FOOTER //
// ./client/app/common/services/services.js